import { render, staticRenderFns } from "./FolderImage.vue?vue&type=template&id=9ee4238a&scoped=true&"
import script from "./FolderImage.vue?vue&type=script&lang=js&"
export * from "./FolderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee4238a",
  null
  
)

export default component.exports